import { EventEmitter } from 'events';
import { TimeDTO } from '../interfaces/TimeDTO';
import { ShootingLiveDTO } from '../interfaces/ShootingLiveDTO';



const GetEmitter = ():EventEmitter => {
    let evmit = new EventEmitter();
    evmit.setMaxListeners(0);
    return evmit;
}
export const eventBus:EventEmitter = GetEmitter();



export interface TimeEvent{
    messageType: string;
    time?: TimeDTO | null;
    status?: string | null;
    startno?: number | null;
    shooting?: ShootingLiveDTO | null;
    order: number | null;
    runtTimeTobeat: string | null;
    timeInDate?: Date | null;
}